export default {
  // common
  ok: 'OK',
  cancel: 'キャンセル',
  send: '送信',
  // time
  timeJustNow: 'たった今',
  timeMinutesAgo: '{n}分前',
  timeHoursAgo: '{n}時間前',
  timeYesterday: '昨日',
  // chat toolbar titles
  chatEmotion: '絵文字',
  chatSendImage: '画像を送信',
  chatSendFile: 'ファイルを送信',
  chatReceipt: '開封確認メッセージ',
  chatSendVoice: '音声を送信',
  chatGroupInfo: 'グループ情報',
  // chat area
  chatSomeoneAtMe: '自分宛のメンションがあります',
  chatNewMessages: '新着メッセージ{n}件',
  chatBackToBottom: '最下部に戻る',
  chatReceiptPrefix: '[開封確認] ',
  // message actions / tips
  chatNoMoreMessages: 'これ以上メッセージはありません',
  chatDeleteConfirm: 'このメッセージを削除しますか？',
  chatDeleteTitle: 'メッセージを削除',
  chatRecallConfirm: 'このメッセージを取り消しますか？',
  chatRecallTitle: 'メッセージを取り消す',
  chatRecalled: 'メッセージを取り消しました',
  chatLocateFail: '元のメッセージが見つかりません',
  chatResendUnsupported: 'このメッセージは自動再送信に対応していません。手動で再送信してください。',
  // input disabled tips
  chatGroupDissolved: 'グループは解散されました',
  chatGroupQuit: 'あなたはこのグループのメンバーではありません',
  chatGroupBanned: 'グループは禁止されています',
  chatUserBanned: 'このアカウントは禁止されています',
  chatBanReason: '、理由：',
  // message status / readed
  msgReaded: '既読',
  msgUnread: '未読',
  msgAllReaded: 'すべて既読',
  msgSomeReaded: '{n}人が既読',
  msgSending: '送信中',
  msgSendFail: '送信失敗',
  msgRecall: '再送信',
  msgMenuDelete: '削除',
  msgMenuRecall: '取り消し',
  // voice record
  recordTitle: '音声録音',
  recordDuration: '録音時間',
  recordStart: '開始',
  recordPause: '一時停止',
  recordResume: '再開',
  recordStop: '停止',
  recordPlay: '再生',
  recordStopPlay: '再生を停止',
  recordRestart: '録り直す',
  recordSend: '今すぐ送信',
  recordStateReady: '未開始',
  recordStateRunning: '録音中...',
  recordStatePaused: '録音一時停止',
  recordStateStopped: '録音停止',
  msgReadedTab: '既読 ({n})',
  msgUnreadTab: '未読 ({n})',
  // language
  langLabel: '言語',
  langZh: '中文',
  langEn: 'English'
}
